import React from "react";
import ResourceList from "./ResourceList";
import ResourcePage from "./ResourcePage";
import { getDescriptor } from "./resources";
import "./style.scss";

export function PointsResourceList(slug) {
  return function Bound(props) {
    return <ResourceList descriptor={getDescriptor(slug)} {...props} />;
  };
}

export function PointsResourcePage(slug) {
  return function Bound(props) {
    return <ResourcePage descriptor={getDescriptor(slug)} {...props} />;
  };
}
